import {ILoggerMessageProps} from './interfaces/logger-message-props.interaface';

export class LoggerMessage {
    constructor(public massage: string | Error, public props: ILoggerMessageProps) {}
}
